var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 7.51562V0.875H1.54688C0.897461 0.875 0.375 1.39746 0.375 2.04688V24.7031C0.375 25.3525 0.897461 25.875 1.54688 25.875H17.9531C18.6025 25.875 19.125 25.3525 19.125 24.7031V8.6875H12.4844C11.8398 8.6875 11.3125 8.16016 11.3125 7.51562ZM15.0454 17.8359L10.3374 22.5088C10.0127 22.8315 9.48828 22.8315 9.16357 22.5088L4.45557 17.8359C3.95996 17.3442 4.30762 16.5 5.00488 16.5H8.1875V12.5938C8.1875 12.1621 8.53711 11.8125 8.96875 11.8125H10.5312C10.9629 11.8125 11.3125 12.1621 11.3125 12.5938V16.5H14.4951C15.1924 16.5 15.54 17.3442 15.0454 17.8359ZM18.7832 6.00195L14.0029 1.2168C13.7832 0.99707 13.4854 0.875 13.1729 0.875H12.875V7.125H19.125V6.82715C19.125 6.51953 19.0029 6.22168 18.7832 6.00195Z",
    fill: "#2369CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b80e8aca1c2df27eba2be6ccd334fa57.svg";
export { ForwardRef as ReactComponent };